import React, { ReactNode } from 'react';
import { Caption } from '../Text/Text';
import { Index, StyledCircle, StyledFlexLi } from './LineItem.styles';

type LineItem = {
  index: ReactNode;
  center?: boolean;
};

export const LineItem: React.FC<LineItem> = ({ children, index, center }) => {
  return (
    <StyledFlexLi center={center}>
      <StyledCircle size="medium">
        <Index>{index}</Index>
      </StyledCircle>
      <Caption>{children}</Caption>
    </StyledFlexLi>
  );
};
